<template>
  <v-card :loading="loading">
    <v-card-text :class="arabic ? `arFont` : 'enFont'" v-if="item && item.items  && item.items.length && item.items[0] && item.items[0].product">
      <v-row>
        <v-col cols="12" class="pt-0 pb-2" v-if="extend">
          <v-btn color="success" :loading="loading" small block @click="reloadData()">{{i18n['reload']}}</v-btn>
        </v-col>
        <v-col cols="12" class="pt-0 pb-2" v-if="master">
          <strong>
            <small>{{ i18n["account_name"]}}</small>
          </strong>
          <br>
          {{item.account.name}} | {{item.account.id}} 
          <v-btn 
            v-clipboard:copy="item.account.id"
            color="success" 
            x-small 
            icon>
            <v-icon size="10">content_copy</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pt-0 pb-2" v-if="master">
          <strong>
            <small>Ninja Product</small>
          </strong>
          <br>
          <v-chip label small :color="`${item.ninja_product?'success':'warning'}`">{{ item.ninja_product ? 'Ninja Product' : 'NEW Product' }}</v-chip>
        </v-col>
        <v-col cols="12" md="6" class="pt-0 pb-2">
          <strong>
            <small>{{ i18n["uid"]}}</small>
          </strong>
          <br>
          {{item.uid}}
          <v-btn 
            v-clipboard:copy="item.uid"
            color="success" 
            x-small 
            icon>
            <v-icon size="10">content_copy</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" md="6" class="pt-0 pb-2">
          <strong>
            <small>{{ i18n["crm_po_key"]}}</small>
          </strong>
          <br>
          {{item.crm_po_key}}
          <v-btn 
            v-clipboard:copy="item.crm_po_key"
            color="success" 
            x-small 
            icon>
            <v-icon size="10">content_copy</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" class="py-0">
          <strong>
            <small>{{ i18n["accepted_quotation_status"]}}</small>
          </strong>
          <br>
          <v-chip label small color="warning" v-if="item.items[0].pending">{{i18n["pending_quotation"] }}</v-chip>
          <v-chip label small color="success" v-if="item.items[0].accepted_quotation">{{i18n["accepted_quotation"] }}</v-chip>
          <v-chip label small color="error" v-if="item.items[0].rejected_quotation">{{i18n["rejected_quotation_successfully"] }}</v-chip>

        </v-col>
        <v-col cols="12" sm="6" class="py-0" v-if="item.items[0].in_warehouse_date">
          <strong>
            <small>{{ i18n["in_warehouse_date"]}}</small>
          </strong>
          <br>
          <v-chip label x-small >{{ item.items[0].in_warehouse_date.split(' ')[0] }}</v-chip>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="py-0">
          <strong>
            <small>{{ i18n["date_created"]}}</small>
          </strong>
          <br>
          <v-chip label x-small >{{ item.created_at.split('T')[0] }}</v-chip>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="py-0">
          <strong>
            <small>{{ i18n["updated_at"]}}</small>
          </strong>
          <br>

          <v-chip label x-small color="primary">{{ item.updated_at.split('T')[0] }}</v-chip>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="py-0">
          <strong>
            <small>{{ i18n["status"]}}</small>
          </strong>
          <br>

          <v-chip label small color="success">{{ i18n['po_' + item.items[0].status.label] }}</v-chip>
        </v-col>
        <v-col cols="8" class="py-2" v-if="item.items[0].product">
          <strong>
            <small>{{ i18n["product_name"]}}</small>
          </strong>
          <br>
          <div>{{ item.items[0].product.title_ar }}</div>
          <div>{{ item.items[0].product.title_en }}</div>
        </v-col>
        <v-col cols="4" class="py-2" v-if="item.items[0].product && item.items[0].product.media.length && item.items[0].product.media[0].url">
          <img :src="item.items[0].product.media[0].url" style="max-height:100px;max-width:100%;" alt="">
        </v-col>
        <v-col cols="6" md="6" class="py-0">
          <strong>
            <small>{{ i18n["quantity"]}}</small>
          </strong>
          <div>{{ item.items[0].quantity }}</div>
          <strong>
            <small>{{ i18n["quotation_quantity"]}}</small>
          </strong>
          <div>{{ item.items[0].quotation_quantity }}</div>
        </v-col>
        <v-col cols="6" md="6" class="py-0">
          <strong>
            <small>{{ i18n["price"]}}</small>
          </strong>
          <div>${{ item.items[0].formatted_price }}</div>
          <strong>
            <small>{{ i18n["quotation_price"]}}</small>
          </strong>
          <div>${{ item.items[0].formatted_quotation_price }}</div>
        </v-col>
        
        <v-col cols="12" sm="6" md="6">
          <strong>
            <small>{{ i18n["origin"]}}</small>
          </strong>
          <br>
          <span>{{  item.items[0].origin }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <strong>
            <small>{{ i18n["destination"]}}</small>
          </strong>
          <br>
          <span>{{  countries[item.items[0].destination] ? countries[item.items[0].destination] : item.items[0].destination }}</span>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="py-0" v-if="item.items[0].date_shipped_at">
          <strong>
            <small>{{ i18n["date_shipped_at"]}}</small>
          </strong>
          <br>
          <v-chip label x-small >{{ item.items[0].date_shipped_at.split(' ')[0] }}</v-chip>
        </v-col>
        <v-col cols="12" sm="6" md="4" class="py-0" v-if="item.items[0].date_recieved_at">
          <strong>
            <small>{{ i18n["date_recieved_at"]}}</small>
          </strong>
          <br>
          <v-chip label x-small >{{ item.items[0].date_recieved_at.split(' ')[0] }}</v-chip>
        </v-col>
        <v-col cols="12" v-if="extend">
          <strong>
            <small>{{i18n["po_item_source_url"]}}</small>
          </strong>
          <br>
          <div class="d-flex justify-content-center w-100 align-items-center">
            
            <v-btn :href="item.items[0].source_url" target="_blank" class="mr-2" color="blue" dark
              x-small>
              <v-icon size="small" class="ml-1">open_in_new</v-icon>
              {{i18n["po_item_source_url"]}}
            </v-btn>
          </div>
        </v-col>
        
        <v-col cols="12" sm="12" md="12" class="py-0" v-if="extend && item.items[0].product.description">
          <strong>
            <small>{{ i18n["description"]}}</small>
          </strong>
          <br>
          {{item.items[0].product.description}}
        </v-col>
        <v-col cols="12" sm="12" md="12" class="py-0" v-if="extend && item.note">
          <strong>
            <small>{{ i18n["note"]}}</small>
          </strong>
          <br>
          {{item.note}}
        </v-col>
        <v-col cols="12" sm="12" md="12" class="py-0" v-if="extend && item.admin_note">
          <strong>
            <small>{{ i18n["admin_note"]}}</small>
          </strong>
          <br>
          {{item.admin_note}}
        </v-col>
        <v-col cols="12" md="6" class="py-0" v-if="item.items[0] && item.items[0].sku">
          <strong>
            <small>{{ i18n["product_sku"]}}</small>
          </strong>
          <br>
          {{item.items[0].sku}}
        </v-col>
        <v-col cols="12" md="6" class="py-0" v-if="item.total">
          <strong>
            <small>{{ i18n["total"]}}</small>
          </strong>
          <br>
          ${{item.formatted_total}}
        </v-col>
        <v-col cols="12" md="6" class="py-0" v-if="item.items[0].product && item.items[0].rejected_quotation">
          <strong>
            <small>{{ i18n["rejected_quotation_successfully"]}}</small>
          </strong>
        </v-col>
        <v-col cols="12" md="6" class="py-0" v-if="item.items[0].product && item.items[0].rejected_quotation">
          <strong>
            <small>{{ i18n["rejected_reason"]}}</small>
          </strong>
          <br>
          {{i18n['reject_' + item.items[0].rejected_reason]}}
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="item.items[0].product && item.items[0].rejected_quotation">
          <strong>
            <small>{{ i18n["rejected_reason_details"]}}</small>
          </strong>
          <br>
          {{item.items[0].rejected_reason_details}}
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="extend && item.payment_method">
          <strong>
            <small>{{ i18n["payment_method"]}}</small>
          </strong>
          <br>
          {{ i18n['po_' + item.payment_method.label] }}
        </v-col>
        <v-col cols="12" md="12" class="py-0" v-if="extend && item.payment_method">
          <strong>
            <small>{{ i18n["proof_of_payment"]}}</small>
          </strong>
          <br>
          <div class="d-flex justify-content-center w-100 align-items-center">
            
            <v-btn :href="item.payment_attachment_url" target="_blank" class="mr-2" color="blue" dark
              x-small>
              <v-icon size="small" class="ml-1">open_in_new</v-icon>
              {{i18n["proof_of_payment"]}}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="4" class="py-0" v-if="extend && item.items[0].received_quantity">
          <strong>
            <small>{{ i18n["received_quantity"]}}</small>
          </strong>
          <br>
          {{ item.items[0].received_quantity }}
        </v-col>
        <v-col cols="12" md="4" class="py-0" v-if="extend && item.invoice_total">
          <strong>
            <small>{{ i18n["invoice_total"]}}</small>
          </strong>
          <br>
          ${{ item.formatted_invoice_total }}
        </v-col>
        <v-col cols="12" md="4" class="py-0" v-if="extend && item.paid_total">
          <strong>
            <small>{{ i18n["paid_total"]}}</small>
          </strong>
          <br>
          ${{ item.formatted_paid_total }}
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text :class="arabic ? `arFont` : 'enFont'" v-if="item && item.items && extend">
      <div class="py-2">
        <strong>
          {{i18n['updates_timeline']}}
        </strong>
      </div>
      <Timeline :updates="updates" :payment_methods="payment_methods" :statuses="statuses" />
    </v-card-text>
    <v-card-actions :class="arabic ? `arFont` : 'enFont'" v-if="!extend">
      <v-spacer></v-spacer>
      <v-btn color="primary" dark small @click.prevent="showItem(item)" v-if="!master">{{i18n['po_show_details']}}</v-btn>
      <v-btn color="primary" dark small @click.prevent="editItem(item)" v-if="master">{{i18n['update']}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Timeline from './Timeline.vue'
export default {
  components: {
    Timeline,
	},
  props:['item', 'index', 'extend', 'loading', 'payment_methods', 'statuses'],
  methods:{
    editItem(item) {
			this.$router.push(`/purchase-order/${item.id}/edit`)
		},
    showItem(item) {
			this.$router.push(`/purchase-order/${item.id}/details`)
		},
    reloadData(){
      this.$emit('reloadData')
    }
  },
  computed:{
    updates(){
      return [...this.$props.item.items[0].updates,...this.$props.item.updates].sort((a, b)=> new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    countries() {
      return this.$store.state.countries_[this.language]
    },
    master() {
      return this.$store.state.user.role == 'master';
    },
  },
}
</script>